import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { InputSuffix } from "#components/atoms/InputSuffix/InputSuffix";
import { centsToEuro, euroToCents, parseInputNumberValue } from "#shared/helpers/prices";

const PRICE_UNIT = "€/format";

const formatEuroInput = (cents: number): string => String(centsToEuro(cents)).replace(".", ",");

type PriceCellProps = {
  value: number;
  onUpdate: (value: number) => void;
};

export const PriceCell = ({ value, onUpdate }: PriceCellProps) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState(formatEuroInput(value));

  useEffect(() => setInputValue(formatEuroInput(value)), [value]);

  const handleBlur = () => {
    const euros = parseInputNumberValue(inputValue);
    if (Number.isNaN(euros) || euros < 0) {
      setInputValue(formatEuroInput(value));
      return;
    }

    const cents = euroToCents(euros);
    if (cents !== value) {
      onUpdate(cents);
    }
  };

  return (
    <InputSuffix
      value={inputValue}
      onChange={setInputValue}
      onBlur={handleBlur}
      suffix={PRICE_UNIT}
      aria-label={t("onboardingV2.rawMaterialSpecification.columns.price")}
    />
  );
};
